export default function About({data}){

  return (
    <section className='p-1 p-md-3 p-lg-5' id='about'>
      <p>{data}
      </p>
    </section>
  )
}